import {
  LOGIN_USER,
  LOGOUT_USER,
  COMMON_UPDATE_USER_PICTURE,
} from './constants'

export function reducer(state, action) {
  switch (action.type) {
    case LOGIN_USER:
      if(!action.token) break;
      localStorage.setItem('token', action.token)
      localStorage.setItem('profile', JSON.stringify(action.profile))
      localStorage.setItem('permitsApp', action.permitsApp)
      localStorage.setItem('license', JSON.stringify(action.license))
      localStorage.setItem('system', JSON.stringify(action.system))
      localStorage.setItem('permissions', JSON.stringify(action.permissions))
      localStorage.setItem('isMobileSystem', JSON.stringify(action.isMobileSystem))
      return {
        ...state,
        user: {
          isLogged: true,
          ...action.profile,
          token: action.token,
          license: action.license,
          system: action.system,
          permissions: action.permissions,
          isMobileSystem: action.isMobileSystem
        }
      };
    case LOGOUT_USER:
      localStorage.removeItem('token')
      localStorage.removeItem('profile')
      localStorage.removeItem('permitsApp')
      localStorage.removeItem('license')
      localStorage.removeItem('system')
      localStorage.removeItem('permissions')
      localStorage.removeItem('isMobileSystem')
      return {
        ...state,
        user: {
          isLogged: false,
          firstname: null,
          lastname: null,
          email: null,
          photo: null,
          token: null,
          license: null,
          system: null,
          permissions: null,
          unit_business:null,
          customFilters: []
        }
      }

      case COMMON_UPDATE_USER_PICTURE:
        return {
          ...state,
          user: {
            ...state.user,
            photo: action.data.profilePictureUrl
          }
        }

    default:
      return state;
  }
}
